import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useEventLocations } from '../../../../../data/hooks/locationHooks';
import CurrentLocation from './CurrentLocation';
import PinIcon from './location-dot-solid-full.svg';
import styles from './LocationSelection.module.scss';
import SelectableLocationListItem from './SelectableLocationListItem';

function LocationSelection(props) {
    const { event, slot, location, onChange } = props,
        allLocations = useEventLocations(event.id),
        locations = useMemo(() => {
            return slot?.location_ids.map((id) => allLocations.find((location) => location.id == id)).filter(Boolean) || [];
        }, [allLocations, slot]),
        [expanded, setExpanded] = useState(!location),
        isExpanded = expanded || !location,
        i18n = useI18n();

    const handleSelectLocation = useCallback(
        (location) => {
            onChange(location);
            if (location) setExpanded(false);
        },
        [onChange]
    );

    useEffect(() => {
        const locationAvailableInSlot = location && locations.find((l) => l.id == location.id);
        if ((!location || !locationAvailableInSlot) && locations.length == 1) {
            handleSelectLocation(locations[0]);
        } else if (location && !locationAvailableInSlot) {
            handleSelectLocation(null);
        }
    }, [slot]);

    return (
        <div className={styles.LocationSelection}>
            {isExpanded ? (
                <>
                    <div>
                        <PinIcon />
                        {i18n['label.select-location']}
                    </div>
                    {locations.map((l) => (
                        <SelectableLocationListItem key={l.id} location={l} onClick={handleSelectLocation} selected={l.id == location?.id} />
                    ))}
                </>
            ) : (
                <CurrentLocation location={location} onClick={() => setExpanded(true)} />
            )}
        </div>
    );
}

export default LocationSelection;
